export const IMAGE_GENERATION_COOLDOWN_MS = 45 * 1000;

const COOLDOWN_KEY_PREFIX = "image_generation_cooldown_until";

const resolveScope = (workspaceId) => {
  const raw = String(workspaceId || "").trim();
  return raw || "global";
};

const getCooldownKey = (workspaceId) =>
  `${COOLDOWN_KEY_PREFIX}:${resolveScope(workspaceId)}`;

const parseTimestamp = (value) => {
  const timestamp = Number(value || 0);
  return Number.isFinite(timestamp) ? timestamp : 0;
};

const readCooldownUntil = (workspaceId) => {
  if (typeof window === "undefined") return 0;
  try {
    return parseTimestamp(window.localStorage?.getItem(getCooldownKey(workspaceId)));
  } catch (error) {
    return 0;
  }
};

export const getImageGenerationCooldownRemainingMs = (workspaceId) =>
  Math.max(0, readCooldownUntil(workspaceId) - Date.now());

export const startImageGenerationCooldown = (
  workspaceId,
  durationMs = IMAGE_GENERATION_COOLDOWN_MS,
) => {
  const safeDuration = Math.max(0, Number(durationMs) || 0);
  const until = Date.now() + safeDuration;
  if (typeof window !== "undefined") {
    try {
      window.localStorage?.setItem(getCooldownKey(workspaceId), String(until));
    } catch (error) {
      // Ignore storage failures.
    }
  }
  return until;
};

export const formatCooldownSeconds = (remainingMs) =>
  Math.max(1, Math.ceil(Math.max(0, Number(remainingMs) || 0) / 1000));
